import styled from 'styled-components';

import InputOption from '../InputOption';

export const Container = styled.div({
  whiteSpace: 'nowrap',
  /**
   * Changed element from <p> to <div> to fix semantic issues.
   * <p> default props were reapplied to avoid any side effects.
   * @see https://inscyth-inc.atlassian.net/browse/EE3-350
   */
  marginBlock: '1em',
  marginInline: '0px',
});

export const Link = styled.span(({ theme }) => ({
  color: theme.palette.blueCola,
  cursor: 'pointer',
  textDecoration: 'underline',
  letterSpacing: '0.08rem',
  marginLeft: '5rem',
}));

export const Input = styled(InputOption)({
  '& label': {
    display: 'flex',
    flexWrap: 'wrap',
  },
});
